(() => {
  'use strict';

  if (window.__tomautoProductQaReady) return;
  window.__tomautoProductQaReady = true;

  const tabletQuery = window.matchMedia('(min-width: 768px) and (max-width: 1199px)');

  function getProductRoots(scope = document) {
    if (
      scope instanceof Element &&
      scope.matches("product-info[id^='MainProduct-']")
    ) {
      return [scope];
    }

    return [...(scope.querySelectorAll?.("product-info[id^='MainProduct-']") || [])];
  }

  function syncReferenceButton(button) {
    const card = button.closest('.tomauto-reference-card');
    const isOpen = Boolean(card?.classList.contains('is-open'));
    const label = isOpen ? 'Ocultar referências' : 'Ver referências';

    button.setAttribute('aria-expanded', String(isOpen));
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);
    button.textContent = isOpen ? '−' : '+';
  }

  function prepareProduct(root) {
    const purchase = root.querySelector('.listing-item__right');
    const sourceTitle = root.querySelector('.product-main-title');
    const priceInfo = purchase?.querySelector('.listing-item__price-info');

    if (
      purchase &&
      sourceTitle &&
      priceInfo &&
      !purchase.querySelector('.tomauto-product-title-tablet')
    ) {
      const title = document.createElement('div');
      title.className = 'tomauto-product-title-tablet';
      title.textContent = sourceTitle.textContent.trim();
      purchase.insertBefore(title, priceInfo);
    }

    root
      .querySelectorAll('.tomauto-reference-link[data-open-oem]')
      .forEach(syncReferenceButton);
  }

  function init(scope = document) {
    getProductRoots(scope).forEach(prepareProduct);
  }

  document.addEventListener('click', (event) => {
    if (!tabletQuery.matches) return;

    const button = event.target.closest?.('.tomauto-reference-link[data-open-oem]');
    if (!button) return;

    const card = button.closest('.tomauto-reference-card');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    card.classList.toggle('is-open');
    syncReferenceButton(button);
  });

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
})();
